import React, { useState, useRef, useEffect } from "react";
import "./modelDropDown.css";

const ModelDropDown = ({ selectedModel, setSelectedModel, translate, langOpt, showWarning = false }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const models = {
    en: [
      { value: "", label: "Select Model" },
      { value: "Super Great", label: "Super Great" },
      { value: "Canter", label: "Canter" },
      { value: "eCanter", label: "eCanter" }
    ],
    jp: [
      { value: "", label: "モデルを選択" },
      { value: "Super Great", label: "スーパーグレート" },
      { value: "Canter", label: "キャンター" },
      { value: "eCanter", label: "イーキャンター" }
    ]
  };

  const getModels = () => {
    return langOpt === "Japanese" ? models.jp : models.en;
  };

  const handleSelect = (value) => {
    setSelectedModel(value);
    setIsOpen(false);
  };

  const getSelectedLabel = () => {
    const currentModels = getModels();
    const selected = currentModels.find(model => model.value === selectedModel);
    return selected ? selected.label : currentModels[0].label;
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="model-dropdown-container">
      <span className="model-dropdown-label">
        {translate ? translate("Vehicle Model") : "Vehicle Model"}
      </span>
      <div className="model-dropdown-inner" ref={dropdownRef}>
        <div className="model-dropdown" onClick={() => setIsOpen(!isOpen)}>
          {getSelectedLabel()}
        </div>
        {isOpen && (
          <div className="model-dropdown-options">
            {getModels().map((model) => (
              <div
                key={model.value}
                className={`model-dropdown-option ${model.value === "" ? "placeholder" : ""}`}
                onClick={() => handleSelect(model.value)}
              >
                {model.label}
              </div>
            ))}
          </div>
        )}
        {showWarning && !selectedModel && (
          <span className="model-dropdown-warning">
            {translate("Please select a model")}
          </span>
        )}
      </div>
    </div>
  );
};

export default ModelDropDown;